module.exports = __webpack_public_path__ + "media/images/logo-proposal-footer-73cae47207e6dfd58c9231e8d42ed0e1.png";